import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { ContactMainForm } from '@/components/modules/pages/contact/main/input/ContactMainForm';
import { ContentContainer } from '@/components/ui/Layout/ContentContainer';
import { Head } from '@/components/ui/Typography/Heading/Head';
/**
 * カジュアル相談 View
 * @param props
 * @returns
 */
export const ContactMainView = (props) => {
    const { className = '', firstNameInputRef, initialValues, lastNameInputRef, onSubmit, title, types, } = props;
    return (_jsxs(ContentContainer, Object.assign({ className: clsx('mx-auto', className) }, { children: [_jsx(Head, Object.assign({ className: 'flex justify-center text-left', size: 'lg' }, { children: title })), _jsx(ContactMainForm, { className: 'mt-12', firstNameInputRef: firstNameInputRef, initialValues: initialValues, lastNameInputRef: lastNameInputRef, onSubmit: onSubmit, types: types })] })));
};
